export default __webpack_public_path__ + "static/media/loading.55178051.svg";